export type WeatherInfo = {
    temperature_c: number;
    wind_speed_kmh: number;
    weather_code: number;
    description: string;
};

const WEATHER_CODE_LABELS: Record<number, string> = {
    0: "Ciel dégagé",
    1: "Plutôt clair",
    2: "Partiellement nuageux",
    3: "Couvert",
    45: "Brouillard",
    48: "Brouillard givrant",
    51: "Bruine légère",
    53: "Bruine modérée",
    55: "Bruine forte",
    61: "Pluie légère",
    63: "Pluie modérée",
    65: "Pluie forte",
    71: "Neige légère",
    73: "Neige modérée",
    75: "Neige forte",
    80: "Averses légères",
    81: "Averses modérées",
    82: "Averses fortes",
    95: "Orage",
    96: "Orage avec grêle",
    99: "Orage violent",
};

type OpenMeteoResponse = {
    current?: {
        temperature_2m: number;
        wind_speed_10m: number;
        weather_code: number;
    };
};

// Uses fetch() instead of axios to avoid global auth headers
// triggering a CORS preflight that Open-Meteo rejects.
export const getWeather = async (lat: number, lng: number): Promise<WeatherInfo> => {
    const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&current=temperature_2m,wind_speed_10m,weather_code`;
    const res = await fetch(url);
    if (!res.ok) {
        throw new Error(`Weather API ${res.status}`);
    }
    const data: OpenMeteoResponse = await res.json();
    if (!data?.current) {
        throw new Error("Invalid weather payload");
    }
    const code = data.current.weather_code;
    return {
        temperature_c: data.current.temperature_2m,
        wind_speed_kmh: data.current.wind_speed_10m,
        weather_code: code,
        description: WEATHER_CODE_LABELS[code] ?? "Inconnu",
    };
};

export const weatherAPI = {
    getWeather,
};

export default weatherAPI;
